/**
 * @file campaignConstant.js
 * @description Constants for the Campaign module.
 *              Includes UI strings, messages, and error definitions.
 *
 * @module campaignConstant
 *
 * @exports CAMPAIGN_STRING   - UI label strings for the campaign module.
 * @exports CAMPAIGN_MESSAGE  - User-facing messages for campaign operations.
 * @exports CAMPAIGN_ERRORS   - Error message strings for campaign-related operations.
 */
export const CAMPAIGN_STRING = {
     
};
export const CAMPAIGN_MESSAGE = {
     SELECT_CAMPAIGN: "Please select a campaign to proceed.",
};

export const CAMPAIGN_ERRORS = {
    FETCH_CAMPAIGN_ERROR: "Error fetching campaigns:",
    UPDATE_CAMPAIGN_ERROR: "Error updating campaign:",
    FETCH_PROCESS_ERROR: "Error fetching processes:",
};


